import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Table } from 'semantic-ui-react';

import metricsShape from './MetricsTableShape';
import SnukTableHeader from '../reusable/SnukTable/SnukTableHeader';
import SnukTableFetchRow from '../reusable/SnukTable/SnukTableFetchRow';

const makeDataFromTelemetry = (shortName, id, startTime, endTime, telemetry) => {
  const machineData = {
    isPending: true,
    machine: shortName,
    id,
    green: 0,
    yellow: 0,
    red: 0,
    off: 0,
  };

  if (!telemetry[id]) {
    return machineData;
  }

  const { isPending, allIds, byId } = telemetry[id];

  if (isPending) {
    return machineData;
  }

  machineData.isPending = false;

  const values = allIds.map(idx => byId[idx]);

  if (values.length === 0) {
    machineData.off += endTime - startTime;
    return machineData;
  }

  if (values.length > 0 && startTime < values[0].timestamp) {
    const nextTimestamp = values[0].timestamp;
    const duration = nextTimestamp - startTime;
    machineData.off += duration;
  }

  for (let i = 0; i < values.length; ++i) {
    const {
      timestamp, red, yellow, green,
    } = values[i];
    const nextTimestamp = (i !== values.length - 1) ? values[i + 1].timestamp : endTime;
    let duration = nextTimestamp - timestamp;

    if (duration <= 0) {
      console.error('Invalid duration received!', duration, timestamp,
        'start:', startTime - timestamp,
        'end:', endTime - timestamp,
        'values:', values[i]);
      duration = 0;
    }

    if (green) {
      machineData.green += duration;
    } else if (yellow) {
      machineData.yellow += duration;
    } else if (red) {
      machineData.red += duration;
    } else {
      machineData.off += duration;
    }
  }

  return machineData;
};

const MetricsTable = (props) => {
  const { getTelemetry, telemetry, machines, startTime, endTime } = props;

  return (
    <Table celled striped textAlign="center">
      <SnukTableHeader
        shape={metricsShape}
        editable={false}
      />
      <Table.Body>
        {machines.map(({ shortName, id }) => {
          const machineData = makeDataFromTelemetry(shortName, id, startTime, endTime, telemetry);

          return (
            <SnukTableFetchRow
              key={id}
              shape={metricsShape}
              isLoading={machineData.isPending}
              fetchAction={() => getTelemetry([id], startTime)}
              values={machineData}
            />
          );
        })}
      </Table.Body>
    </Table>
  );
};

MetricsTable.propTypes = {
  startTime: PropTypes.number.isRequired,
  endTime: PropTypes.number.isRequired,
  machines: PropTypes.arrayOf(PropTypes.shape({
    shortName: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
  })).isRequired,
  getTelemetry: PropTypes.func.isRequired,
  telemetry: PropTypes.shape({}).isRequired,
};

export default translate()(MetricsTable);



// WEBPACK FOOTER //
// ./src/components/Metrics/MetricsTable.js